import { render, staticRenderFns } from "./gruposCaja.vue?vue&type=template&id=1744b983"
import script from "./gruposCaja.vue?vue&type=script&lang=js"
export * from "./gruposCaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports